import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { KITS } from '@/data/kits';
import { Section, SectionTitle } from '@/components/landing/Section';
import { KitDetailModal } from '@/components/landing/KitDetailModal';

export function Kits() {
  return (
    <Section id="kits">
      <SectionTitle subtitle="Elegí el kit que mejor protege tu hogar o negocio. Tocá un kit para ver el detalle.">
        Seguridad que se adapta a tu estilo de vida
      </SectionTitle>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {KITS.map((kit, i) => (
          <KitDetailModal key={kit.id} kit={kit}>
            <motion.button
              type="button"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              whileHover={{ y: -4 }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className={cn(
                'relative flex h-full flex-col rounded-2xl border bg-white/[0.02] p-6 text-left transition-colors hover:border-primary/60 hover:bg-white/[0.04]',
                kit.badge ? 'border-primary' : 'border-white/[0.06]',
              )}
            >
              {kit.badge && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-primary px-3 py-1 text-xs font-bold text-primary-foreground">
                  {kit.badge}
                </span>
              )}
              <h3 className="text-xl font-bold text-white">{kit.name}</h3>
              <p className="mt-1 text-sm text-slate-400">{kit.idealFor}</p>
              <ul className="mt-4 flex-1 space-y-1.5 text-sm text-slate-400">
                {kit.includes.slice(0, 4).map((item) => (
                  <li key={item}>• {item}</li>
                ))}
                {kit.includes.length > 4 && (
                  <li className="text-xs">+ {kit.includes.length - 4} más</li>
                )}
              </ul>
              <span className="mt-4 text-sm font-semibold text-primary">Ver detalles →</span>
            </motion.button>
          </KitDetailModal>
        ))}
      </div>
    </Section>
  );
}
